import React from 'react'
import G2ReviewModal from 'src/component-modal/G2ReviewModal/G2ReviewModal'
import { useG2ReviewEnabled } from 'src/component-modal/G2ReviewModal/useG2ReviewEnabled'
import { useModalRoute } from 'src/navigation/modalParams'
import { g2ReviewOverlayRoute } from 'src/navigation/overlayRoutes'

/**
 * Renders the G2 review modal from the URL (`?modal=g2Review`), mounted once in
 * `Authed.tsx` alongside the other overlays.
 *
 * The param check lives here rather than inline in `Authed` so the URL-to-modal
 * wiring can be tested on its own — `Authed` is not mountable in a unit test, so
 * an inline check is coverable only by never being exercised at all.
 *
 * The brand gate is not optional: `useG2ReviewEnabled` is the same check that
 * decides whether the profile trigger renders. Because the modal is reachable
 * from any URL carrying the param — a shared link, a deep link, a campaign — it
 * must re-assert the gate itself rather than trusting its entry point.
 */
const G2ReviewOverlay: React.FC = () => {
  const modal = useModalRoute()
  const isG2ReviewEnabled = useG2ReviewEnabled()

  if (!isG2ReviewEnabled || modal.name !== g2ReviewOverlayRoute.name) {
    return null
  }

  return <G2ReviewModal isOpen onClose={modal.close} />
}

export default G2ReviewOverlay
